import _isEmpty from 'lodash/isEmpty';

import { helper } from '@ember/component/helper';

function isEmptyObj([check]: any[] /*, hash*/) {
  return _isEmpty(check);
}

const isEmptyObjHelper = helper(isEmptyObj);
export default isEmptyObjHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-empty-obj': typeof isEmptyObjHelper;
  }
}
